module.exports = __webpack_public_path__ + "img/Niehaus@2x.7c6485ab.webp";